import React, { useState, useEffect } from "react";
import Header3 from "../../components/header/header-rslhome";
import Footer3 from "../../components/footer/footer-new";
import Seo from "../../components/common/Seo";
import Banner from "../../components/location/banner";
import LocationCard from "../../components/location/locationCard";
import { useDispatch, useSelector } from "react-redux";
import { locationListFromTaxi } from "../../redux/slices/product";
import { useRouter } from "next/router";
import { fetchSeoByPage } from "../../lib/seoHelper";

export default function Location({ meta }) {
    const dispatch = useDispatch();
    const router = useRouter();
    const { locationListFromTaxiRes } = useSelector((state) => state.product);
    const [locations, setLocations] = useState([]);
    const [type, setType] = useState(1);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const obj = {
            company_id: 0
        };
        dispatch(locationListFromTaxi(obj));
    }, [dispatch]);

    useEffect(() => {
        if (locationListFromTaxiRes) {
            if (locationListFromTaxiRes.status === 1) {
                setLocations(locationListFromTaxiRes.responseData || []);
            } else {
                setLocations([]);
            }
            setIsLoading(false);
        }
    }, [locationListFromTaxiRes]);

    const handleLocationClick = (type, mainLocation) => {
        if (type === 1) {
            router.push(`/location/location-details/${mainLocation._id}`)
        } else {

        }
    };

    return (
        <>
            <Seo meta={meta} />
            <div>
                <Header3 />
                <Banner title="Our <br /> Locations" />
                <LocationCard
                    title="Enhance Your <br /> Travel Experience"
                    type={type}
                    locations={locations}
                    isLoading={isLoading}
                    onLocationClick={handleLocationClick}
                />
            </div>
            <Footer3 />
        </>
    );
}

export async function getServerSideProps(context) {
    const rawPath = context.resolvedUrl;
    let path = rawPath.split("?")[0];
    if (path.length > 1 && path.endsWith("/")) {
        path = path.slice(0, -1);
    }
    const metaHome = await fetchSeoByPage(path);
    return {
        props: { meta: metaHome }
    };
}